export default "__VITE_ASSET__DKQGOTgZ__"